import * as React from "react";

interface GameOverIconProps {}

export const GameOverIcon: React.FC<GameOverIconProps> = () => (
  <svg height="112px" width="112px" viewBox="0 0 496 512">
    <path
      fill="currentColor"
      d="M248 8a248 248 0 100 496 248 248 0 000-496zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9a20 20 0 000-28.3L196.3 192l17.9-17.9a20 20 0 00-28.3-28.3L168 163.7l-17.8-17.8a20 20 0 00-28.3 28.3l17.9 17.9-17.9 17.9a20 20 0 0028.3 28.3l17.8-17.8 17.8 17.8a20.2 20.2 0 0028.4-.2zm160-92.2a20 20 0 00-28.3 0L328 163.7l-17.8-17.8a20 20 0 00-28.3 28.3l17.9 17.9-17.9 17.9a20 20 0 0028.3 28.3l17.8-17.8 17.8 17.8a20 20 0 0028.3-28.3l-17.8-18 17.9-17.9a20.1 20.1 0 000-28.2zM248 272a64 64 0 10.1 128.1A64 64 0 00248 272z"
    />
  </svg>
);
